import { initCmpExponea } from './cmp';
import { initAdobeScript } from './adobeDataLayer';

type CmpConfigData = {
  cmpid: string;
  waitconsentimport: string;
  exponea: boolean;
  datalayer: string;
  variant: string;
};

declare global {
  interface Window {
    adobeDataLayer: unknown[];
    o2cmpConfigData?: CmpConfigData;
    o2cmpUserConsentInfo: string;
    denyMultiTabs: boolean;
    __cmp: (action: string) => void;
  }
}

// AdobeDataLayer init is left here because other script files depends on it.
window.adobeDataLayer = window.adobeDataLayer || [];

/**
 *
 * @param adobeLaunchPath - URL path of adobe launch script.
 * @param cmpId - Magic constant given by Ondřej Sláma. Seems like this value is valid for all MO2 modules.
 * @param cmpVersion - Magic constant given by Ondřej Sláma. Seems like this value is valid for all MO2 modules.
 */
export const initScripts = (
  adobeLaunchPath: string,
  cmpId = '34520',
  cmpVersion = 'new_usersense',
) => {
  initCmpExponea(cmpId, cmpVersion);

  initAdobeScript(adobeLaunchPath);
};
